"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var getURI = function getURI(id) {
  return "composition/v1/compositions/" + id + "/share";
};

var ShareManager = /*#__PURE__*/function () {
  function ShareManager() {
    (0, _classCallCheck2.default)(this, ShareManager);
  }

  (0, _createClass2.default)(ShareManager, [{
    key: "shareWithEmails",
    value: function shareWithEmails(_ref) {
      var compositionId = _ref.compositionId,
          emails = _ref.emails;
      return _apiClient.default.post(getURI(compositionId), {
        data: {
          emails: emails
        }
      });
    }
  }]);
  return ShareManager;
}();

exports.default = ShareManager;
module.exports = exports.default;